import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";

import { PageHeader } from "@/components";
import { TabPanel } from "@/components/Tabs/Tabs";

import { SignalConfig } from "./components/SignalConfig";
import { SignalsHistory } from "./components/SignalsHistory";

enum SignalsTab {
	SIGNALS = "SIGNALS",
	SIGNALS_HISTORY = "SIGNALS_HISTORY",
}

export const Signals: FunctionComponent = () => {
	const { t } = useTranslation();
	const [activeTab, setActiveTab] = useState<string>(SignalsTab.SIGNALS);

	const tabs = [
		{ label: t("list.signals.tabs.signals"), value: SignalsTab.SIGNALS },
		{ label: t("list.signals.tabs.signalsHistory"), value: SignalsTab.SIGNALS_HISTORY },
	];

	return (
		<div className="min-h-full w-full pb-24">
			<PageHeader
				activeTab={activeTab}
				tabs={tabs}
				title={t("list.signals.title")}
				onTabChange={setActiveTab}
			/>

			<TabPanel activeTab={activeTab} value={SignalsTab.SIGNALS}>
				<SignalConfig />
			</TabPanel>

			<TabPanel activeTab={activeTab} value={SignalsTab.SIGNALS_HISTORY}>
				<SignalsHistory />
			</TabPanel>
		</div>
	);
};
